import React, { useEffect, useState } from "react";
import { Divider } from "@mui/material";
import { FaInstagram, FaLinkedin, FaTwitter, FaYoutube } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa6";
import { useLocation, useParams } from "react-router-dom";
import { s3baseUri } from "../../config/config";
import { useIds } from "../../hook/AdminContext";
import { show_proper_words } from "../../utils/Constant";
import { useSnackbar } from "notistack";
import PageLoading from "../../components/loader/PageLoading";
import RecordNoImage from "../../components/recordNotFound/RecordNoImage";
import { get_client_details } from "../../DAL/clientTypes/ClientTpes";
import ClientDetails from "./components/ClientDetails";
import CircularLoader from "../../components/loader/CircularLoader";

export default function ClientDetail() {
  const { enqueueSnackbar } = useSnackbar();
  const { client_detail_id, source_slug, type_slug, sector_slug } = useParams();
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState({});
  const { setBreadCrumb, userInfo } = useIds();
  const location = useLocation();
  const firstSegment = location.pathname.split("/")[1];

  const handleFetchDetails = async () => {
    const response = await get_client_details(
      client_detail_id
      // source_slug || ""
    );
    if (response.code === 200) {
      setCategories({
        ...response.user,
        client_type:
          response?.user?.client_type.filter((type) => type?.sector?.title) ||
          [],
      });
      setLoading(false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
    }
  };

  useEffect(() => {
    handleFetchDetails();
  }, []);

  useEffect(() => {
    setBreadCrumb([
      {
        name: `${show_proper_words(source_slug)}`,
        path: `/${source_slug}/home`,
        active: false,
      },

      {
        name: `Clients`,
        path: `/${source_slug}/type/${type_slug}${
          sector_slug ? `/${sector_slug}` : ""
        }`,
        active: false,
      },
      {
        name: `Client Detail`,
        path: ``,
        active: true,
      },
    ]);
  }, []);

  if (loading) {
    return <CircularLoader />;
  }

  return (
    <div className="container-fluid mt-3">
      <div className="row">
        <div className="col-12">
          <div className="heading-main">
            <h2 className="ms-0">
              {show_proper_words(
                type_slug?.endsWith("s") ? type_slug.slice(0, -1) : type_slug
              )}{" "}
              Detail
            </h2>
          </div>
        </div>
        <ClientDetails data={categories} fetchDetails={handleFetchDetails} />
      </div>
    </div>
  );
}
